import { BinType } from 'commons/enums';
import { ProductDetail } from 'commons/types';

import { SwipeRxWmsApi } from '../resources';
import { SwipeRxAPIResources } from '../resources/types';

import {
  IPickingJobPickedItemRequest,
  IPickingJobPickedItemVerificationRequest,
  IPickingJobProductDetailRequest,
  IPickingJobProductDetailResponse,
  IPickingJobRecommendationRequest,
  IPickingJobRecommendationResponse,
  IPickingJobRemoveBatchRequest,
  IPickingJobResponse,
  IPickingJobVerifyBarcodeRequest,
} from './types';

class SwipeRxWmsApiPickJob extends SwipeRxWmsApi {
  constructor() {
    super(SwipeRxAPIResources.PICKING_JOB);
  }

  async getPickJobs(): Promise<IPickingJobResponse[]> {
    const result = await this.get(`${this.apiResource}`);
    if (result && result.data) {
      return result.data as IPickingJobResponse[];
    }
    return [];
  }

  /**
   * @deprecated might not be used in the future. Will preserve the endpoint for a while
   */
  async getRecommendation(
    params: IPickingJobRecommendationRequest,
  ): Promise<IPickingJobRecommendationResponse[]> {
    const result = await this.get(`${this.apiResource}/recommendation`, params);
    if (result && result.data) {
      return result.data as IPickingJobRecommendationResponse[];
    }
    return [];
  }

  async getBinRecommendationInfo(
    skuCode: string,
    binType: BinType,
  ): Promise<ProductDetail[]> {
    const result = await this.get(
      `${this.apiResource}/${skuCode}/bin-recommendation/${binType}/info`,
    );

    return result.data;
  }

  async getProductDetail(params: IPickingJobProductDetailRequest): Promise<{
    error?: string | true;
    data?: IPickingJobProductDetailResponse;
  }> {
    try {
      const result = await this.get(
        `${this.apiResource}/product-detail`,
        params,
      );
      const data = result.data as IPickingJobProductDetailResponse;
      return { data };
    } catch (error: unknown) {
      if (error instanceof Error) {
        return { error: error.message };
      }
      return { error: true };
    }
  }

  async postPickedItem(params: IPickingJobPickedItemRequest): Promise<boolean> {
    try {
      await this.post(`${this.apiResource}/pick-item`, params);
      return true;
    } catch (error) {
      return false;
    }
  }

  async postPickedItemVerification(
    params: IPickingJobPickedItemVerificationRequest,
  ): Promise<boolean> {
    try {
      const result = await this.post(
        `${this.apiResource}/pick-item/verify`,
        params,
      );
      return result?.data?.success || false;
    } catch (error) {
      return false;
    }
  }

  async postBarcodeVerification(
    params: IPickingJobVerifyBarcodeRequest,
  ): Promise<void> {
    await this.post(`${this.apiResource}/barcode/verify`, params);
  }

  async postRemoveBatch(params: IPickingJobRemoveBatchRequest): Promise<void> {
    try {
      await this.post(`${this.apiResource}/remove-batch`, params);
    } catch (error) {
      // TODO send alert ?
    }
  }

  async postCompletePick(lineNumber: number): Promise<void> {
    await this.post(`${this.apiResource}/complete-pick-item`, {
      line_number: lineNumber,
    });
  }
}

export const swiperxWmsApiPickJob = new SwipeRxWmsApiPickJob();
